import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { TextEllipsis } from './../../TextEllipsis';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-s7ypth-0"
})(["padding:18px 0;"]);
export var SubjectBlock = styled.div.withConfig({
  displayName: "partials__SubjectBlock",
  componentId: "sc-s7ypth-1"
})(["margin-top:9px;margin-bottom:2px;color:", ";", " > span{color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
}, function (_ref2) {
  var _ref2$font = _ref2.font,
    font = _ref2$font === void 0 ? -1 : _ref2$font;
  return "".concat(getFont(font));
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.font;
});
export var ReviewTitle = styled.h4.withConfig({
  displayName: "partials__ReviewTitle",
  componentId: "sc-s7ypth-2"
})(["", " font-weight:700;color:", ";&:hover{text-decoration:underline;}"], getFont(1, 'compact'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.terciaryD;
});
export var ReviewBody = styled.div.withConfig({
  displayName: "partials__ReviewBody",
  componentId: "sc-s7ypth-3"
})(["color:", ";", " width:100%;overflow-wrap:break-word;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:", ";&:before{content:'\u201C';}&:after{content:'\u201D';}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.font;
}, getFont(0, 'compact'), function (_ref6) {
  var _ref6$lines = _ref6.lines,
    lines = _ref6$lines === void 0 ? 1 : _ref6$lines;
  return lines;
});
export var RatingContainer = styled.div.withConfig({
  displayName: "partials__RatingContainer",
  componentId: "sc-s7ypth-4"
})(["margin-top:6px;"]);